// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__eYAgj","inner":"Form_inner__14vmC","range":"Form_range__6hPj4","name":"Form_name__2EdMX","actions":"Form_actions__2mjCq"};